<mat-toolbar>

  <div class="buttons">
    @if (hasFilters$ | async) {
      <button mat-flat-button color="primary" (click)="clearFilters()" i18n="@@core.attribute-list.clear-filters">Clear filters</button>
    }
    @if (hasFiltersForOtherFeatureTypes$ | async) {
      <button mat-flat-button color="primary" (click)="clearAllFilters()" i18n="@@core.attribute-list.clear-all-filters">Clear all filters</button>
    }
    <ng-template #attributeListFeaturesContainer></ng-template>
    <tm-attribute-list-export-button></tm-attribute-list-export-button>
    @if (loadingData$ | async) {
      <mat-spinner color="primary" mode="indeterminate" diameter="20"></mat-spinner>
    }
    @if (showZoomToButton$ | async) {
      <button mat-flat-button
              color="primary"
              (click)="zoomToDataBounds()"
              i18n="@@core.attribute-list.zoom-to-bounds"
              i18n-tmTooltip="@@core.attribute-list.zoom-to-bounds.tooltip"
              tmTooltip="Zoom to data bounds">Zoom to</button>
    }
  </div>

  @if (pagingData$ | async; as pagingData) {
    <div class="paging">
      <mat-paginator [pageSize]="pagingData.pageSize"
        [pageIndex]="pagingData.pageIndex - 1"
        [length]="pagingData.totalCount || 0"
        [hidePageSize]="true"
        [disabled]="loadingData$ | async"
        [showFirstLastButtons]="true"
        (click)="showJumpToPage($event)"
        (page)="onPageChange($event)">
      </mat-paginator>
    </div>
  }

</mat-toolbar>
